export default __webpack_public_path__ + "static/media/brand16.45d05492.svg";